'use strict';

var I; I || (I = {});

$(function($) {
    $(document).ready(function(){
        // Select tree nodes.
        $(document).on('click', '.i-tree-node.i-action-select', function(event) {
            var $this = $(this),
                tree = $this.closest('.i-tree'),
                selected = tree.find('.i-tree-node.i-state-select'),
                id = tree.data('model-id');

            if (!$this.hasClass('i-state-select')) {
                if (selected) {
                    selected.removeClass('i-state-select');
                }
                $this.addClass('i-state-select');
                
                event.stopPropagation();
            }
            
            updateStats();
        });

        $(document).on('change', '#pv-mode', function(event) {
            var mode = $(this).val();

            if ('dir' === mode) {
                $('#pv-dir-tree').removeClass('hide');
                $('#pv-cat-tree').addClass('hide');
            } else {
                $('#pv-cat-tree').removeClass('hide');
                $('#pv-dir-tree').addClass('hide');
            }
            
            updateStats();
        });

        $(document).on('change', '#pv-from-epoch', function(event) {
            updateStats();
        });
        
        $(document).on('change', '#pv-to-epoch', function(event) {
            updateStats();
        });
        
        $(document).on('change', '#pv-analyzer', function(event) {
            updateStats();
        });
        
        //Activating Bootstrap tabs
        $(".tab-container .nav-pills a").click(function(e){
            e.preventDefault();
            $(this).tab('show');
        });
    });

    // Shrinkable lists
    var lists = $("ul.shrinkable");

    $(lists).each(function() {
        var el = $(this);
        if (el.find('li').length > 6 ) {
            el.append( "<button>{%= __('More') =%}</button>" );
            $(el).find('li:nth-child(n+6)').hide();
            $(el).find('button').on('click', function(event) {
                var target = $( event.target );
                if ($(target).text() == "{%= __('More') =%}") {
                    $(target).text("{%= __('Hide') =%}");
                } else {
                    $(target).text("{%= __('More') =%}");
                }
                $(el).find('li:nth-child(n+6)').slideToggle('fast');
            })
        }    
    });

    // Toggle tree pane
    $(document).on('click', '#i-mam-tree-toggle',function(event){
            var $this = $(this), 
                $tree = $('.tree_container'),
                $pv = $('.preformanceview_container'),
                id = $this.attr("id"),
                $btn_element = $this.find('#' + id + "-btn");

            event.preventDefault();
            
            $tree.toggle();
            $pv.toggleClass('i-col-md-12');
            $btn_element.find('i').toggleClass('fa-caret-right');
    });

    // Responsive tabs
    // media query event handler
    if (matchMedia) {
      var mq = window.matchMedia("(min-width: 780px)");
      mq.addListener(WidthChange);
      WidthChange(mq);
    }

    // media query change
    function WidthChange(mq) {
      if (mq.matches) {
        // window width is at least 780px
        $(".nav-pills li.active").each(function() {
            $(this).siblings('.tab-content').insertBefore($(this).closest('ul'));
        });
      } else {
        // window width is LESS than 780px
        $(".nav-pills li.active").each(function() {
            $(this).closest('ul').siblings('.tab-content').insertBefore($(this));
        });
        $(".nav-pills li").on('click', function(event) {
            $(this).siblings('.tab-content').insertBefore($(this));
        });
      }
    }

    // Return the value of all form fields.  If one is undefined, the
    // calendar is not yet ready.
    function collectParams() {
        var params = {};

        params.from = $('#pv-from-epoch').val();
        if (params.from === "" || params.from === undefined) return;
        
        params.to = $('#pv-to-epoch').val();
        if (params.to === "" || params.to === undefined) return;

        params.mode = $('#pv-mode').val();
        params.recursive = $('#pv-recursive').prop('checked');
        
        params.analyzer = $('#pv-analyzer').val();

        var tree_id = '#pv-' + params.mode + '-tree',
            selected = $(tree_id).find('.i-state-select'),
            node_id = selected.data('nodeId'),
            type = selected.data('nodeType');

        params.id = node_id;
        params.action = 'data';
        
        params.type = (type === 'uri' || type === 'doc') ? 'leaf' : 'node';
        
        return params;
    }

    var visitorChart = AmCharts.makeChart("pv-visitors",
            {
                type: "serial",
                theme: "light",
                categoryField: "date",
                rotate: false,
                pathToImages: '/imperia/assets/images/amcharts/',
                legend: {
                    enabled: true
                },
                chartCursor: {
                    enabled: true
                },
                export: {
                    enabled: true,
                    libs: {
                        autoLoad: false
                    }
                },
                responsive: {
                    enabled: true
                },
                categoryAxis: {
                    gridPosition: "start",
                    parseDates: true
                },
                valueAxes: [
                    {
                        position: "top",
                        title: "Visitors"
                    },
                    {
                        position: "bottom",
                        title: "Pages"
                    }
                ],
                graphs: [
                    {
                        type: "line",
                        title: "Page Impressions",
                        valueField: "page_views",
                        bullet: "round",
                    },
                    {
                        type: "line",
                        title: "Unique visitors",
                        valueField: "unique_visitors",
                        bullet: "round",
                    },
                    {
                        type: "line",
                        title: "Visitors",
                        valueField: "visits",
                        bullet: "round",
                    }
                ],
                dataProvider: []
            }
        );

    var behaviorChart = AmCharts.makeChart("pv-behavior",
            {
                type: "serial",
                theme: "light",
                categoryField: "date",
                rotate: false,
                pathToImages: '/imperia/assets/images/amcharts/',
                legend: {
                    enabled: true
                },
                chartCursor: {
                    enabled: true
                },
                export: {
                    enabled: true,
                    libs: {
                        autoLoad: false
                    }
                },
                responsive: {
                    enabled: true
                },
                categoryAxis: {
                    gridPosition: "start",
                    parseDates: true
                },
                valueAxes: [
                    {
                        position: "top",
                        title: "Percentage"
                    }
                ],
                graphs: [
                         {
                             type: "line",
                             title: "Bounce Rate",
                             valueField: "bounce_rate",
                             bullet: "round",
                         },
                         {
                             type: "line",
                             title: "Returning Visitors",
                             valueField: "returning_rate",
                             bullet: "round",
                         }
                ],
                dataProvider: []
            }
        );

    var referralsChart = AmCharts.makeChart("pv-referrers-referrals",
        {
    	    type: "pie",
    	    theme: "default",
            colors: [
                     "#67b7dc",
                     "#fdd400",
                     "#84b761",
                     "#cc4748",
                     "#cd82ad",
                     "#2f4074",
                     "#448e4d",
                     "#b7b83f",
                     "#b9783f",
                     "#b93e3d",
                     "#913167"
                     ],
            angle: 45,
            depth3D: 15,
            innerRadius: 0,
            titleField: "name",
            categoryField: "name",
            valueField: "visits",
            rotate: false,
            pathToImages: '/imperia/assets/images/amcharts/',
            legend: {
                enabled: true
            },
            export: {
                enabled: true,
                libs: {
                    autoLoad: false
                }
            },
            responsive: {
                    enabled: true
            },
    	    dataProvider: []
        }
    );

    // FIXME! Is there a clone method that we can use instead?
    var channelsChart = AmCharts.makeChart("pv-referrers-channels",
        {
    	    type: "pie",
    	    theme: "default",
            colors: [
                     "#67b7dc",
                     "#fdd400",
                     "#84b761",
                     "#cc4748",
                     "#cd82ad",
                     "#2f4074",
                     "#448e4d",
                     "#b7b83f",
                     "#b9783f",
                     "#b93e3d",
                     "#913167"
                     ],
            angle: 45,
            depth3D: 15,
            innerRadius: 0,
            titleField: "name",
            categoryField: "name",
            valueField: "visits",
            rotate: false,
            pathToImages: '/imperia/assets/images/amcharts/',
            legend: {
                enabled: true
            },
            export: {
                enabled: true,
                libs: {
                    autoLoad: false
                }
            },
            responsive: {
                    enabled: true
            },
    	    dataProvider: []
        }
    );

    var browsersChart = AmCharts.makeChart("pv-browsers",
        {
    	    type: "pie",
    	    theme: "default",
            colors: [
                     "#67b7dc",
                     "#fdd400",
                     "#84b761",
                     "#cc4748",
                     "#cd82ad",
                     "#2f4074",
                     "#448e4d",
                     "#b7b83f",
                     "#b9783f",
                     "#b93e3d",
                     "#913167"
                     ],
            //angle: 45,
            //depth3D: 15,
            innerRadius: 20,
            titleField: "name",
            categoryField: "name",
            valueField: "visits",
            rotate: false,
            pathToImages: '/imperia/assets/images/amcharts/',
            legend: {
                enabled: true
            },
            export: {
                enabled: true,
                libs: {
                    autoLoad: false
                }
            },
            responsive: {
                    enabled: true
            },
    	    dataProvider: []
        }
    );

    var osChart = AmCharts.makeChart("pv-os",
        {
    	    type: "pie",
    	    theme: "default",
            colors: [
                     "#67b7dc",
                     "#fdd400",
                     "#84b761",
                     "#cc4748",
                     "#cd82ad",
                     "#2f4074",
                     "#448e4d",
                     "#b7b83f",
                     "#b9783f",
                     "#b93e3d",
                     "#913167"
                     ],
            //angle: 45,
            //depth3D: 15,
            innerRadius: 20,
            titleField: "name",
            categoryField: "name",
            valueField: "visits",
            rotate: false,
            pathToImages: '/imperia/assets/images/amcharts/',
            legend: {
                enabled: true
            },
            export: {
                enabled: true,
                libs: {
                    autoLoad: false
                }
            },
            responsive: {
                    enabled: true
            },
    	    dataProvider: []
        }
    );

    function updateStats() {
    	$('.pv-loading').removeClass('hide');
    	$('.pv-ready').addClass('hide');
    	
        var params = collectParams();
        
        if (params === undefined) {
            // Calendar not yet ready, wait.
            window.setTimeout(updateStats, 1);
            return;
        }

        var uri = I.Util.uri('/document/performanceview');
        $.getJSON(uri, params, function(result) {
        	if (result.error)
        		return;
        	
            visitorChart.dataProvider = result.data;
            visitorChart.validateData();
            //visitorChart.startEffect = 'easeInSine';
            //visitorChart.sequencedAnimation = true;
            //visitorChart.startDuration = 0.20;
            //visitorChart.animateAgain();
            
            behaviorChart.dataProvider = result.data;
            behaviorChart.validateData();
            //behaviorChart.startEffect = 'easeOutSine';
            //behaviorChart.sequencedAnimation = true;
            //behaviorChart.startDuration = 0.20;
            //behaviorChart.animateAgain();
            
            referralsChart.dataProvider = result.referrers;
            referralsChart.validateData();
            //referralsChart.startEffect = 'bounce';
            //referralsChart.sequencedAnimation = true;
            //referralsChart.startDuration = 1;
            //referralsChart.animateAgain();
            
            channelsChart.dataProvider = result.referrerChannels;
            channelsChart.validateData();
            //channelsChart.startEffect = 'bounce';
            //channelsChart.sequencedAnimation = true;
            //channelsChart.startDuration = 1;
            //channelsChart.animateAgain();
            
            browsersChart.dataProvider = result.browsers;
            browsersChart.validateData();
            //browsersChart.startEffect = 'bounce';
            //browsersChart.sequencedAnimation = true;
            //browsersChart.startDuration = 1;
            //browsersChart.animateAgain();
            
            osChart.dataProvider = result.os;
            osChart.validateData();
            //osChart.startEffect = 'bounce';
            //osChart.sequencedAnimation = true;
            //osChart.startDuration = 1;
            //osChart.animateAgain();
            
            $('.pv-loading').addClass('hide');
            $('.pv-ready').removeClass('hide');
        });
    }

    updateStats();
});
